import React from 'react';
import ProductHero from "../../assets/images/portfolio/4.jpg";
import { motion } from 'framer-motion';

const ESGManagementHero = () => {
  const LIST_OF_KEY_CAPABILITIES = [
    { id: "1", listItem: "Centralize ESG, sustainability, and EHS data across the organization" },
    { id: "2", listItem: "Monitor environmental performance, risks, and incidents in real time" },
    { id: "3", listItem: "Ensure regulatory compliance and maintain audit-ready documentation" },
    { id: "4", listItem: "Improve transparency, decision-making, and stakeholder reporting" },
  ];

  return (
    <article className={`flex flex-col items-center p-4 pt-36 pb-18
            bg-gradient-to-b from-green-600/20 dark:from-green-600/40 via-green-600/10 dark:via-green-600/20 to-transparent`}>

      <section className={`container grid grid-cols-1 md:grid-cols-[60%_40%] gap-6 md:gap-12 items-center`}>

        {/* Left Text */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          className="flex flex-col justify-center gap-4 md:gap-6"
        >
          <h6 className="lg:text-5xl text-4xl font-medium mb-2 position-relative dark:text-white">
            ESG management is now easier than ever
          </h6>
          <p className="text-slate-500 dark:text-white/70 mb-0 max-w-2xl text-lg">
            SATTVA - Safe and Sustainable is an integrated solution that helps organizations manage sustainability initiatives, ESG performance, environmental impact, risk, and compliance through a single, centralized platform.
          </p>

          <h6 className="text-lg font-semibold text-slate-800 dark:text-white
                   group-hover:text-white transition-colors duration-300">Key Capabilities</h6>
          <ul className="">
            {LIST_OF_KEY_CAPABILITIES.map(item => (
              <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300
                       group-hover:text-white/90 text-base" key={item.id}><span className="mt-2 h-1.5 w-1.5 rounded-full bg-blue-600 group-hover:bg-white "></span>{item.listItem}</li>
            ))}
          </ul>
        </motion.div>

        {/* Right Image */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.2 }}
          className='w-full h-[300px] md:h-[450px] lg:h-[500px] rounded-xl overflow-hidden relative'
        >
          <img
            src={ProductHero}
            alt="ESG Management"
            className='w-full h-full object-cover rounded-xl shadow-lg md:shadow-xl transform hover:scale-105 transition duration-500 ease-in-out'
          />
          {/* Optional subtle overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent rounded-xl pointer-events-none"></div>
        </motion.div>

      </section>
    </article>
  );
}

export default ESGManagementHero;
